import { useHelpSidebarVisibility } from '../store/useHelpSidebarVisibility';
import { useProgramColor } from '../store/useProgramColor';

export const Layout = ( {Header , Body, Footer, Help, settings} : any) => {    

    const {isHelpSidebarVisible} = useHelpSidebarVisibility();
    const style = isHelpSidebarVisible ? {display: 'grid', gridTemplateColumns: '1fr 450px'} : {};
    const { programColor } = useProgramColor();

    return (
        <div className={`${programColor} flex h-screen flex-col overflow-hidden text-[var(--neutral-gray-120)]`}>
            <div className="z-20 flex-shrink-0">
                <Header settings={settings}/>
            </div>
            <div className="relative flex flex-1 flex-col overflow-hidden" style={style}>
                <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden pb-20">
                    <Body/>
                </div>
                <Footer/>
                {isHelpSidebarVisible && <Help/>}
            </div>
        </div>
    );
} 
